import axios, { AxiosError, AxiosRequestConfig } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import {
  CLIENT_RETENTION_PATH,
  ISSUED_DOCUMENTS,
  UPLOAD_PATH,
  REPROCESS_PENDING_PATH,
} from "../../constants/paths"
import { IIssuedDocument } from "types/response/issuedDocumentsResponse"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

const formDataConfig: AxiosRequestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
}

export const uploadReceivedDocumentsService = async (
  file1: File | null,
  file2: File | null
) => {
  const formData = new FormData()
  if (file1) {
    formData.append("arFile", file1)
  }
  if (file2) {
    formData.append("ruFile", file2)
  }
  try {
    const result = await instance.post(
      CLIENT_RETENTION_PATH + UPLOAD_PATH,
      formData,
      formDataConfig
    )
    return result.status
  } catch (error: any) {
    const e: AxiosError = error
    return e.response?.status || 0
  }
}

export const getIssuedDocumentsService = async (rif: string) => {
  try {
    const result = await instance.get(
      CLIENT_RETENTION_PATH + ISSUED_DOCUMENTS,
      { params: { rif } }
    )
    return result.data as IIssuedDocument[]
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const reprocessPendingDocumentsService = async () => {
  try {
    const result = await instance.post(
      CLIENT_RETENTION_PATH + REPROCESS_PENDING_PATH,
    )
    return result
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

